import { useQuery } from "@tanstack/react-query";
import { getPresence } from "../api/chains";
import type { PresenceBySystem } from "../types/chain";

export function usePresence(chainId: string | null) {
  return useQuery<PresenceBySystem>({
    queryKey: ["chains", chainId, "presence"],
    queryFn: () => getPresence(chainId!),
    enabled: chainId != null,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
  });
}
